export const EMAIL_REQUIRED_MESSAGE = 'Email is required.'
export const EMAIL_INVALID_MESSAGE = 'Email is not valid.'
export const PASSWORD_REQUIRED_MESSAGE = 'Password is required.'
export const PASSWORD_MIN_LENGTH_MESSAGE = 'Password Must be 6 characters long.'
export const NEW_PASSWORD_REQUIRED_MESSAGE = 'New Password is required.'
export const CONFIRM_PASSWORD_REQUIRED_MESSAGE = 'Confirm Password is required.'
export const PASSWORD_MISMATCH_MESSAGE = 'Password and Confirm Password not Matched'
